import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import { Prompt, useLocation } from 'react-router-dom';
import ConfirmationModal from 'components/ConfirmationModal';
import { useTranslation } from 'react-i18next';

interface Props {
  when?: boolean | undefined;
  navigate: (path: string) => void;
  shouldBlockNavigation: (location: Location) => boolean;
}
const RouteLeavingGuard = ({ when, navigate, shouldBlockNavigation }: Props) => {
  const { t } = useTranslation();
  const currentLocation = useLocation();
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (
      !confirmedNavigation &&
      shouldBlockNavigation(nextLocation) &&
      nextLocation.pathname !== currentLocation.pathname
    ) {
      setShowConfirmDialog(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
    setConfirmedNavigation(false);
  }, [confirmedNavigation, lastLocation]);

  const onConfirmResponse = async (res: boolean) => {
    if (res) {
      setConfirmedNavigation(true);
    }
    setShowConfirmDialog(false);
  };

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <ConfirmationModal
        show={showConfirmDialog}
        cancelButtonTextKey={t('confirmation_save_before_leave_no')}
        text={t('confirmation_save_before_leave_text')}
        onResponse={onConfirmResponse}
      />
    </>
  );
};
export default RouteLeavingGuard;
